import moment from 'moment-timezone';
import { Store } from 'redux';
import { IshState } from 'src/js/services/IshState';
/**
 * this utils collect useful function to format different data types: date, string .....
 */

/**
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
 */
const MONEY_FORMAT = {
  format: (val: number, locale: string, currencyCode: string) => typeof val === 'number' ? val.toLocaleString(locale, {style: 'currency', currency: currencyCode, minimumFractionDigits: 2}) : val,
};

/**
 * Format date string in ISO8601 to string with this pattern
 */
export const formatDate = (dateISO8601: string, pattern: string, timezone?: string): string => {

  // apply timezone if it provided
  if (timezone) {
    return dateISO8601 ? moment(dateISO8601).tz(timezone).format(pattern) : null;
  }

  return dateISO8601 ? moment(dateISO8601).format(pattern) : null;
};

/**
 * Return string with a currency symbol
 */

class Format {
  private store: Store<IshState>;

  public setStore = (_store) => {
    this.store = _store;
  }

  public formatMoney = (value: number): string => {
    const loaction = this.store.getState().preferences?.location;
    return MONEY_FORMAT.format(value, `${loaction?.languageCode || 'en'}-${loaction?.countryCode || 'US'}`, loaction?.currency?.currencySymbol || 'USD');
  };
}

export const FormatService = new Format();

export const formatMoney = FormatService.formatMoney;

/**
 * Return string hashed in sha256
 */
export function hashSha256(string): Promise<string> {
  const utf8 = new TextEncoder().encode(string);

  if (!crypto?.subtle?.digest) {
    return Promise.resolve(string);
  }

  return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray
      .map((bytes) => bytes.toString(16).padStart(2, '0'))
      .join('');
  });
}
